import React from "react";
import { Link } from "@/components/common/Link";
import { Button } from "@/components/ui/button";
import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
import { ArrowRight } from "lucide-react";
export default function Hero() {
  const {
    ref,
    isVisible
  } = useRevealOnScroll({
    threshold: 0.1
  });
  return <section data-section-id="21745" id="our-landscaping-services" className="relative flex min-h-[80vh] w-full items-center justify-center overflow-hidden bg-cover bg-center bg-no-repeat py-24 text-center bg-background text-foreground" style={{
    backgroundImage: "url('https://wpvc-images.s3.us-east-1.amazonaws.com/images/1624735/img/garden-planning-blueprints.png')"
  }}>
      {}
      <div className="absolute inset-0 bg-background/70 backdrop-blur-[2px]" />

      {}
      <div ref={ref} className={`relative z-10 container mx-auto px-4 transition-all duration-1000 ease-out ${isVisible ? "translate-y-0 opacity-100" : "translate-y-10 opacity-0"}`}>
        <div className="mx-auto max-w-4xl space-y-8">
          <h1 className="font-default text-4xl font-bold tracking-tight text-primary sm:text-5xl md:text-6xl lg:text-7xl">
            Residential & Commercial Landscaping Excellence
          </h1>
          
          <p className="mx-auto max-w-2xl text-lg text-secondary font-default sm:text-xl md:text-2xl">
            Twins Landscaping Corp. transforms Rockland and Orange County properties with architectural precision, sustainable garden design, and meticulous seasonal care.
          </p>

          <div className="flex flex-col items-center justify-center gap-4 sm:flex-row">
            <Button asChild size="lg" className="h-14 px-8 text-lg font-semibold shadow-md transition-transform hover:scale-105 bg-primary text-primary-foreground rounded-sm">
              
            </Button>
            
            <Button asChild variant="outline" size="lg" className="h-14 border-primary/30 bg-accent px-8 text-lg font-semibold text-primary backdrop-blur-sm transition-transform hover:scale-105 hover:bg-accent/20 hover:text-primary border rounded-sm">
              <Link to="#">
                Explore Our Services
              </Link>
            </Button>
          </div>
        </div>
      </div>
    </section>;
}